import { SearchState } from '@/domain/search/types'
import {
  isNonEmptyObject,
  isNonEmptyString,
  isNumber,
  isUndefined
} from '@/utils/checks'
export const boostedCategories = ['what_we_treat', 'who_we_treat']
import { boostLocalSponsorForCityLocations } from './boostLocalSponsorForCityLocations'
import { Center } from '@/types/models'
import { formatQualityScore } from './formatQualityScore'
import { getExistingQualityScore } from './getExistingQualityScore'
import { adjustSponsoredCenters } from './adjustSponsoredCenters'
import { centerMatchesSpecializations } from './centerMatchesSpecializations'
import { getMatchedSearchTerm } from './getMatchedSearchTerm'
import { boostMultiSearchCenter } from './boostMultiSearchCenter'
import { adjustPrimaryFocus } from './adjustPrimaryFocus'
import { centerProviderTypeMatchesLevelOfCare } from './centerProviderTypeMatchesLevelOfCare'
import isEligibleForProviderTypeBoost from './isEligibleForProviderTypeBoost'
import { getProviderType } from '@/domain/center'
import { isFacetPageType, isLocationPageType } from '../pageTypeCheck'
import { handleAdCenterPriority } from './handleAdCenterPriority'
import { PageType } from '@/types/models/PageType.model'
import { shouldBoostResidentialProvider } from './shouldBoostResidentialProvider'
export const getScore = ({
  center,
  searchState,
  staticRandom,
  locationType,
  primaryFocus,
  pageType
}: {
  center: Center
  searchState?: SearchState['refinementList'] | SearchState
  staticRandom?: number | (() => number)
  locationType?: string
  primaryFocus?: string
  pageType?: PageType
}): number => {
  let score = 0
  try {
    const { budget_pacing, sponsor_tier, new_specializations } = center

    let primaryFocusMatchValue

    let searchTerm

    if (!center?.fromBrowseSearch) {
      searchTerm = getMatchedSearchTerm(searchState)
    }

    const qualityScore = getExistingQualityScore(center)
    score += formatQualityScore(qualityScore, staticRandom as number)

    if (isNonEmptyString(center?.primaryFocus)) {
      primaryFocusMatchValue = adjustPrimaryFocus({
        center,
        primaryFocus,
        pageType
      })

      score += primaryFocusMatchValue
    }
    if (isNonEmptyString(searchTerm) && !center?.fromBrowseSearch) {
      score += centerMatchesSpecializations(new_specializations, searchTerm)
    }

    if (isEligibleForProviderTypeBoost(searchTerm, center, pageType)) {
      score += centerProviderTypeMatchesLevelOfCare(
        getProviderType(center),
        searchTerm
      )
    }

    if (isLocationPageType(pageType)) {
      score += shouldBoostResidentialProvider(center)
    }

    if (center?.fromBrowseSearch && isNonEmptyObject(searchState)) {
      score += boostMultiSearchCenter(
        new_specializations,
        searchState as SearchState['refinementList']
      )
    }

    if (isFacetPageType(pageType as PageType) && isNumber(center?.priority)) {
      score += handleAdCenterPriority(center)
    }
    score += adjustSponsoredCenters(
      sponsor_tier as number,
      budget_pacing as number
    )
    if (locationType) {
      score += boostLocalSponsorForCityLocations(
        sponsor_tier as number,
        locationType
      )
    }
    return score
  } catch (error) {
    console.error('error on calculating score', error)
    return score
  }
}
